import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id", "label", "portalId"];
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const windowHasHbsptCtaRunner = window => window && 'hbspt' in window && 'cta' in window.hbspt && 'load' in window.hbspt.cta;

/**
 * A HubSpot CTA with link tracking managed by the CMS. When `label` is
 * supplied, this becomes a `UIButton` with CMS link tracking enabled. The
 * `href` is set within the CMS CTA UI. To enable tracking, these links will
 * point to `https://cta-redirect.hubspot.com/cta/redirect/${portalId}/${id}`.
 *
 * @see https://tools.hubteamqa.com/ui-library/show/UIComponents/button/UIButton
 * @see https://app.hubspot.com/ctas/53/
 */
const CTA = _ref => {
  let {
      id,
      label,
      portalId = 53
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  /**
   * The CMS tracking link.
   */
  const trackingHref = `https://cta-redirect.hubspot.com/cta/redirect/${portalId}/${id}`;
  useEffect(() => {
    /**
     * Loading the CTA script will fetch any multivariate or smart variations
     * in the CMS CTA. If a `label` is supplied, only its text and link-tracking
     * href will be used so there is no need to load the script and swap out
     * variants.
     */
    if (!label) {
      const script = document.createElement('script');
      script.src = 'https://js.hscta.net/cta/current.js';
      document.body.appendChild(script);
      script.addEventListener('load', () => {
        if (windowHasHbsptCtaRunner(window)) {
          window.hbspt.cta.load(portalId, id, {
            useNewLoader: 'true'
          });
        }
      });
    }
  }, [id, portalId, label]);

  /**
   * Link node for the CTA, wrapped by a `<p />`.
   */
  const ctaNode = label ? /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    href: trackingHref,
    children: label
  })) :
  /*#__PURE__*/
  // @bend-expect trellis-tokenized we do not want to mess with these.
  _jsx("span", {
    className: "hs-cta-wrapper",
    id: `hs-cta-wrapper-${id}`,
    children: /*#__PURE__*/_jsx("span", {
      className: `hs-cta-node hs-cta-${id}`,
      id: `hs-cta-${id}`,
      children: /*#__PURE__*/_jsx("a", {
        href: trackingHref,
        children: /*#__PURE__*/_jsx("img", {
          className: "hs-cta-img",
          id: `hs-cta-img-${id}`,
          src: `https://no-cache.hubspot.com/cta/default/${portalId}/${id}.png`,
          alt: I18n.text('developer-docs-mdx-components.accessibility.navigateToPage')
        })
      })
    })
  });
  return /*#__PURE__*/_jsx("p", {
    children: ctaNode
  });
};
export default CTA;